import styled, { css } from 'styled-components';
import Popover from '@mindtickle/popover';
import theme from '@mindtickle/styles/lib/theme';
import { tokens } from '@mindtickle/styles/lib';
import mixins, { textStyles } from '@mindtickle/styles/lib/mixins';
import ButtonWithIcon from '@mindtickle/button/lib/ButtonWithIcon';

const StyledKScore = styled.div`
  color: ${tokens.brandTokens.COLOR_BRAND_PRIMARY};
  ${textStyles.headingMedium};
  display: flex;
  align-items: center;
`;

export const StyledKScorePopover = styled(Popover)`
  .mtdls-popover-content > .mtdls-popover-inner {
    width: 320px;
    padding: 24px;
    z-index: ${mixins.zIndex.ZINDEX_TEN};
    box-shadow: ${theme.boxShadow.LEVEL1};
    border-radius: 8px;
  }
`;

export const halfStarStyles = css`
  font-size: 16px;
`;

export const StyledKScoreHeadingWrapper = styled.div`
  ${mixins.clearfix()};
`;

export const StyledButtonWithIcon = styled(ButtonWithIcon)`
  float: right;
  margin-top: 24px;

  &&.mtdls-btn-primary {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export default StyledKScore;
